"use client";

import { Button, TextInput, Toggle } from "@/ui";
import React from "react";
import AuthPage from "@/app/(auth)/components/AuthPage";
import { getTenantInfo } from "@/lib/theme/tenant";
import FormikInput from "@/ui/forms/FormikInput";
import { Field, Form, Formik, useFormik, useFormikContext } from "formik";
import { LoginPayload, validateLoginForm } from "@/app/(auth)/data";

export default function LoginForm({ onSubmit, onForgotPassword }) {
    const tenantInfo = getTenantInfo();

    return (
        <Formik<LoginPayload>
            initialValues={{ email: "", password: "", rememberMe: true }}
            onSubmit={onSubmit}
            validate={validateLoginForm}>
            {(form) => (
                <AuthPage
                    strapline={`Welcome back to your ${tenantInfo.appName}`}>
                    <h2 className="text-xl font-semibold font-poppins">
                        Login
                    </h2>
                    <p className="text-base font-lato mt-1">
                        Enter your email and password to login
                    </p>

                    <Form>
                        <div className="space-y-8 my-8">
                            <FormikInput
                                id="email"
                                name="email"
                                type="email"
                                label="Email Address"
                            />
                            <FormikInput
                                id="password"
                                name="password"
                                label="Password"
                                type="password"
                            />

                            <Field name="rememberMe">
                                {({ field, form: { setValue, ...fm } }) => (
                                    <Toggle
                                        leftLabel="Remember me for 14 days"
                                        value={field.value}
                                        onChange={(val) =>
                                            fm.setFieldValue("rememberMe", val)
                                        }
                                    />
                                )}
                            </Field>
                        </div>
                        <div className="space-y-4">
                            <Button
                                id="auth-button"
                                fill
                                onClick={form.submitForm}
                                disabled={form.isSubmitting}>
                                Log in
                            </Button>
                            <Button
                                fill
                                variant="link"
                                disabled={form.isSubmitting}
                                href="/forgot-password">
                                Forgot password
                            </Button>
                        </div>
                    </Form>
                </AuthPage>
            )}
        </Formik>
    );
}
